/** Pure habitat weights shared by worker grass and main-thread vegetation. */
import type { TerrainSample } from '@hyperlight/shared';

const smooth=(a:number,b:number,x:number)=>{const t=Math.max(0,Math.min(1,(x-a)/(b-a)));return t*t*(3-2*t)};
type CanyonGround=Pick<TerrainSample,'canyonGround'>;
/** Callers apply these after their complete original candidate RNG draws. */
export function canyonCanopySuppression(ts:CanyonGround):number{return smooth(.06,.70,ts.canyonGround??0)}
export function canyonLawnSuppression(ts:CanyonGround):number{return .985*smooth(.03,.55,ts.canyonGround??0)}
export function canyonCoverSuppression(ts:CanyonGround):number{return smooth(.03,.55,ts.canyonGround??0)}
